import { animate, transition, trigger, query, style } from '@angular/animations';

export const tableAnimation = trigger('tableAnimation', [
  transition('* => *', [
    query(':enter .row-height-set', style({ opacity: 0, maxHeight: 0, overflow: 'hidden' }), {
      optional: true,
    }),
    query(
      ':enter .row-height-set',
      animate('250ms ease-in', style({ opacity: 1, maxHeight: '100px' })),
      {
        optional: true,
      }
    ),
    query(':leave .row-height-set', style({ overflow: 'hidden', maxHeight: '100px' }), {
      optional: true,
    }),
    query(
      ':leave .row-height-set',
      animate('250ms ease-out', style({ opacity: 0, maxHeight: 0 })),
      {
        optional: true,
      }
    ),
  ]),
]);
